/* eslint-disable */
export default {
  _Smr_BG: 'Smr_BG',
  _Atm_BG: 'Atm_BG',
  _Cmn_EndBG: 'Cmn_EndBG',
  _pauseBG: 'pauseBG',
  _tileBgLarge: 'tileBgLarge',
  _Title_Puzzle_1: 'Title_Puzzle_1',
  _Title_Slider_1: 'Title_Slider_1',
  _Btn_Unicorn: 'Btn_Unicorn',
  _Btn_Wood: 'Btn_Wood',
  _Btn_Space: 'Btn_Space',
  _Btn_Autumn: 'Btn_Autumn',
  _Btn_Spring: 'Btn_Spring',
  _Btn_Smr: 'Btn_Smr',
  _Btn_Camo: 'Btn_Camo',
  _Btn_Neon_Lwr: 'Btn_Neon_Lwr',
  _Btn_Neon_Upr: 'Btn_Neon_Upr',
  _Btn_Wntr: 'Btn_Wntr',
  _Btn_Classic: 'Btn_Classic',
  _Atm_Tray: 'Atm_Tray',
  _LtrCase_A: 'LtrCase_A',
  _LtrCase_LwrA: 'LtrCase_LwrA',
  _Sprng_Btn_Hlp: 'Sprng_Btn_Hlp',
  _Sprng_Btn_Restart: 'Sprng_Btn_Restart',
  _Title_A_1: 'Title_A_1',
  _tileBgSmall: 'tileBgSmall',
  _LtrCase: 'LtrCase',
  _Smr_Btn_Hlp: 'Smr_Btn_Hlp',
  _Smr_Btn_Restart: 'Smr_Btn_Restart',
  _Title_C_1: 'Title_C_1',
  _Wntr_Tile_Grn: 'Wntr_Tile_Grn',
  _Title_B_1: 'Title_B_1',
  _Wood_Btn_Hlp: 'Wood_Btn_Hlp',
  _Spc_Tile: 'Spc_Tile',
  _Smr_Tile: 'Smr_Tile',
  _Clsc_Btn_Hlp: 'Clsc_Btn_Hlp',
  _Smr_Tray: 'Smr_Tray',
  _Wntr_Btn_Hlp: 'Wntr_Btn_Hlp',
  _Wntr_Btn_Restart: 'Wntr_Btn_Restart',
  _Wntr_Tray: 'Wntr_Tray',
  _Atm_Tile: 'Atm_Tile',
  _Cmn_Btn_SndOn: 'Cmn_Btn_SndOn',
  _Clsc_Btn_Restart: 'Clsc_Btn_Restart',
  _Neon_Btn_Hlp: 'Neon_Btn_Hlp',
  _Cmn_Btn_SndOff: 'Cmn_Btn_SndOff',
  _Title_ArrowL: 'Title_ArrowL',
  _Title_ArrowR: 'Title_ArrowR',
  _Uncrn_Sprkl: 'Uncrn_Sprkl',
  _Camo_BG: 'Camo_BG',
  _Clsc_BG: 'Clsc_BG',
  _Sprng_Tile_Blue: 'Sprng_Tile_Blue',
  _Sprng_Tile_Pnk: 'Sprng_Tile_Pnk',
  _Wntr_Tile_Red: 'Wntr_Tile_Red',
  _Clsc_Tile_Blue: 'Clsc_Tile_Blue',
  _Sprng_Tile_Prp: 'Sprng_Tile_Prp',
  _Clsc_Tile_Grn: 'Clsc_Tile_Grn',
  _Sprng_Tile_Ylw: 'Sprng_Tile_Ylw',
  _Sprng_Tray: 'Sprng_Tray',
  _Atm_Btn_Hlp: 'Atm_Btn_Hlp',
  _Camo_Tray: 'Camo_Tray',
  _Cmn_EndStar: 'Cmn_EndStar',
  _Camo_Tile2: 'Camo_Tile2',
  _Camo_Tile3: 'Camo_Tile3',
  _Atm_Btn_Restart: 'Atm_Btn_Restart',
  _Camo_Tile4: 'Camo_Tile4',
  _Spc_Tray: 'Spc_Tray',
  _Camo_Btn_Hlp: 'Camo_Btn_Hlp',
  _Camo_Btn_Restart: 'Camo_Btn_Restart',
  _Cmn_Btn_Retry: 'Cmn_Btn_Retry',
  _Camo_Tile1: 'Camo_Tile1',
  _Btn_Play: 'Btn_Play',
  _Cmn_Btn_Cancl: 'Cmn_Btn_Cancl',
  _Cmn_Btn_Home: 'Cmn_Btn_Home',
  _Cmn_Btn_MuteBG: 'Cmn_Btn_MuteBG',
  _Neon_Lwr_a: 'Neon_Lwr_a',
  _Neon_Lwr_b: 'Neon_Lwr_b',
  _Neon_Lwr_c: 'Neon_Lwr_c',
  _Neon_Lwr_d: 'Neon_Lwr_d',
  _Neon_Lwr_e: 'Neon_Lwr_e',
  _Neon_Lwr_f: 'Neon_Lwr_f',
  _Neon_Lwr_g: 'Neon_Lwr_g',
  _Neon_Lwr_h: 'Neon_Lwr_h',
  _Neon_Lwr_i: 'Neon_Lwr_i',
  _Neon_Lwr_j: 'Neon_Lwr_j',
  _Neon_Lwr_k: 'Neon_Lwr_k',
  _Neon_Lwr_l: 'Neon_Lwr_l',
  _Neon_Lwr_m: 'Neon_Lwr_m',
  _Neon_Lwr_n: 'Neon_Lwr_n',
  _Neon_Lwr_o: 'Neon_Lwr_o',
  _Neon_Lwr_p: 'Neon_Lwr_p',
  _Neon_Lwr_q: 'Neon_Lwr_q',
  _Neon_Lwr_r: 'Neon_Lwr_r',
  _Neon_Lwr_s: 'Neon_Lwr_s',
  _Neon_Lwr_t: 'Neon_Lwr_t',
  _Neon_Lwr_u: 'Neon_Lwr_u',
  _Neon_Lwr_v: 'Neon_Lwr_v',
  _Neon_Lwr_w: 'Neon_Lwr_w',
  _Neon_Lwr_x: 'Neon_Lwr_x',
  _Neon_Lwr_y: 'Neon_Lwr_y',
  _Neon_Lwr_z: 'Neon_Lwr_z',
  _Neon_Tile_1: 'Neon_Tile_1',
  _Neon_Tile_2: 'Neon_Tile_2',
  _Neon_Tile_3: 'Neon_Tile_3',
  _Neon_Tile_4: 'Neon_Tile_4',
  _Neon_Tile_5: 'Neon_Tile_5',
  _Neon_Upr_A: 'Neon_Upr_A',
  _Neon_Upr_B: 'Neon_Upr_B',
  _Neon_Upr_C: 'Neon_Upr_C',
  _Neon_Upr_D: 'Neon_Upr_D',
  _Neon_Upr_E: 'Neon_Upr_E',
  _Neon_Upr_F: 'Neon_Upr_F',
  _Neon_Upr_G: 'Neon_Upr_G',
  _Neon_Upr_H: 'Neon_Upr_H',
  _Neon_Upr_I: 'Neon_Upr_I',
  _Neon_Upr_J: 'Neon_Upr_J',
  _Neon_Upr_K: 'Neon_Upr_K',
  _Neon_Upr_L: 'Neon_Upr_L',
  _Neon_Upr_M: 'Neon_Upr_M',
  _Neon_Upr_N: 'Neon_Upr_N',
  _Neon_Upr_O: 'Neon_Upr_O',
  _Neon_Upr_P: 'Neon_Upr_P',
  _Neon_Upr_Q: 'Neon_Upr_Q',
  _Neon_Upr_R: 'Neon_Upr_R',
  _Neon_Upr_S: 'Neon_Upr_S',
  _Neon_Upr_T: 'Neon_Upr_T',
  _Clsc_Tile_Orng: 'Clsc_Tile_Orng',
  _Clsc_Tile_Prp: 'Clsc_Tile_Prp',
  _Neon_Upr_U: 'Neon_Upr_U',
  _Clsc_Tile_Red: 'Clsc_Tile_Red',
  _Neon_Upr_V: 'Neon_Upr_V',
  _Clsc_Tray: 'Clsc_Tray',
  _Neon_Upr_W: 'Neon_Upr_W',
  _Wood_Btn_Restart: 'Wood_Btn_Restart',
  _Neon_Upr_X: 'Neon_Upr_X',
  _Spc_Btn_Restart: 'Spc_Btn_Restart',
  _Neon_Upr_Y: 'Neon_Upr_Y',
  _Neon_Btn_Restart: 'Neon_Btn_Restart',
  _Neon_Tray: 'Neon_Tray',
  _Neon_Upr_Z: 'Neon_Upr_Z',
  _Spc_Btn_Hlp: 'Spc_Btn_Hlp',
  _Uncrn_Btn_Hlp: 'Uncrn_Btn_Hlp',
  _Uncrn_Btn_Restart: 'Uncrn_Btn_Restart',
  _Uncrn_Tile: 'Uncrn_Tile',
  _Uncrn_Tray: 'Uncrn_Tray',
  _Wood_Tile1: 'Wood_Tile1',
  _Wood_Tile2: 'Wood_Tile2',
  _Wood_Tile3: 'Wood_Tile3',
  _Wood_Tile4: 'Wood_Tile4',
  _Wood_Tile5: 'Wood_Tile5',
  _Wood_Tile6: 'Wood_Tile6',
  _Wood_Tile7: 'Wood_Tile7',
  _Wood_Tile8: 'Wood_Tile8',
  _Wood_Tile9: 'Wood_Tile9',
  _Wood_Tile10: 'Wood_Tile10',
  _Wood_Tray: 'Wood_Tray',
  _Spc_BG: 'Spc_BG',
  _Sprng_BG: 'Sprng_BG',
  _Uncrn_BG: 'Uncrn_BG',
  _Wntr_BG: 'Wntr_BG',
  _Wood_BG: 'Wood_BG',
  _Neon_BG: 'Neon_BG',
}